import { graphql } from '@/graphql-setup'

/* TimeEntry mutations */

export const CREATE_TIME_ENTRY_MUTATION = graphql(`
  mutation CreateTimeEntry($input: CreateTimeEntryInput!) {
    createTimeEntry(input: $input) {
      timeEntry {
        id
      }
    }
  }
`)

export const PATCH_TIME_ENTRY_MUTATION = graphql(`
  mutation PatchTimeEntry($id: ID!, $input: PatchTimeEntryInput!) {
    patchTimeEntry(id: $id, input: $input) {
      timeEntry {
        id
      }
      wasOverridden
    }
  }
`)

export const DELETE_TIME_ENTRY_MUTATION = graphql(`
  mutation DeleteTimeEntry($id: ID!) {
    deleteTimeEntry(id: $id) {
      found
      deletedId
    }
  }
`)

/* Absence mutations */

export const CREATE_ABSENCE_MUTATION = graphql(`
  mutation CreateAbsence($input: CreateAbsenceInput!) {
    createAbsence(input: $input) {
      absence {
        id
      }
    }
  }
`)

export const PATCH_ABSENCE_MUTATION = graphql(`
  mutation PatchAbsence($id: ID!, $input: PatchAbsenceInput!) {
    patchAbsence(id: $id, input: $input) {
      absence {
        id
      }
    }
  }
`)

export const DELETE_ABSENCE_MUTATION = graphql(`
  mutation DeleteAbsence($id: ID!) {
    deleteAbsence(id: $id) {
      found
    }
  }
`)

export const MANAGE_ABSENCE_REQUESTS_MUTATION = graphql(`
  mutation ManageAbsenceRequests($approve: [ID!]!, $reject: [ID!]!) {
    manageAbsenceRequests(approve: $approve, reject: $reject) {
      numApproved
      numRejected
    }
  }
`)

export const MANAGE_ABSENCE_TYPE_TRANSACTIONS_MUTATION = graphql(`
  mutation ManageAbsenceTypeTransactions(
    $absenceTypeId: ID!
    $userId: ID!
    $date: DateTime!
    $deduct: Float!
    $reason: String!
  ) {
    manageAbsenceTypeTransactions(
      absenceTypeId: $absenceTypeId
      userId: $userId
      date: $date
      deduct: $deduct
      reason: $reason
    ) {
      absenceType {
        id
      }
    }
  }
`)

export const CREATE_ABSENCE_TYPE_MUTATION = graphql(`
  mutation CreateAbsenceTypeMutation($input: CreateAbsenceTypeInput!) {
    createAbsenceType(input: $input) {
      absenceType {
        id
        name
      }
    }
  }
`)

export const PATCH_ABSENCE_TYPE_MUTATION = graphql(`
  mutation PatchAbsenceTypeMutation($id: ID!, $input: PatchAbsenceTypeInput!) {
    patchAbsenceType(id: $id, input: $input) {
      absenceType {
        id
        name
      }
    }
  }
`)

export const DELETE_ABSENCE_TYPE_MUTATION = graphql(`
  mutation DeleteAbsenceTypeMutation($id: ID!) {
    deleteAbsenceType(id: $id) {
      found
    }
  }
`)

export const LOCK_ABSENCES_MUTATION = graphql(`
  mutation LockAbsences(
    $lockActions: Int
    $adminOverride: Boolean
    $permanent: Boolean
    $until: Date
    $timezone: String
  ) {
    lockAbsences(
      lockActions: $lockActions
      adminOverride: $adminOverride
      permanent: $permanent
      until: $until
      timezone: $timezone
    ) {
      ok
    }
  }
`)

export const UNLOCK_ABSENCES_MUTATION = graphql(`
  mutation UnlockAbsences {
    unlockAbsences {
      ok
    }
  }
`)

export const UPSERT_ABSENCE_LOCK_CONFIG_MUTATION = graphql(`
  mutation UpsertAbsenceLockConfig(
    $id: ID
    $name: String!
    $enabled: Boolean!
    $timezone: String!
    $lockActions: Int!
    $adminOverride: Boolean!
    $permanent: Boolean!
    $rules: [AbsenceLockRuleInput!]!
  ) {
    upsertAbsenceLockConfig(
      id: $id
      name: $name
      enabled: $enabled
      timezone: $timezone
      lockActions: $lockActions
      adminOverride: $adminOverride
      permanent: $permanent
      rules: $rules
    ) {
      absenceLockConfig {
        id
      }
    }
  }
`)

export const DELETE_ABSENCE_LOCK_CONFIG_MUTATION = graphql(`
  mutation DeleteAbsenceLockConfig($id: ID!) {
    deleteAbsenceLockConfig(id: $id) {
      found
    }
  }
`)
